import { render, staticRenderFns } from "./ProjectTable.vue?vue&type=template&id=4b6a1796&"
import script from "./ProjectTable.vue?vue&type=script&lang=js&"
export * from "./ProjectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports